import { useCallback } from "react";
import { useMISReportDownload } from "../../../../hooks/useMISReportDownload";
import { FIELDS_CLAIMS_REJECTIONS } from "../../../../constants/misDownloadData";
import { ATP_API_URL } from "../../../../config/apiconfig";

export const useClaimRejectionDownload = () => {
  const dataMapper = useCallback(
    (item, index) => ({
      "SR. No ": item.sr_no,
      "Claim ID": item.claim_id || "-",
      PNR: item.pnr_number || "-",
      "Customer Name": item.customerName || "-",
      "Train Number": item.trainNumber || "-",
      "Travel Date": item.journey_date || "-",
      "Rejection Reason": item.rejection_reason || "-",
      "Uploaded Proof Status": item.uploadedProofStatus || "-",
      Remarks: item.remarks || "-",
    }),
    [],
  );

  return useMISReportDownload({
    reportType: "claim-rejection",
    reportName: "Claim Rejection",
    fields: FIELDS_CLAIMS_REJECTIONS,
    dataMapper,
    apiUrl: ATP_API_URL.GET_ALL_CLAIMS,
    sheetName: "Claim Rejection",
  });
};

export default useClaimRejectionDownload;
